export function can(permissions, module, subModule, action) {
  if (!permissions) return false;

  if (permissions?.["*"]?.["*"]?.["*"]) return true;

  const moduleKey = String(module || "").toUpperCase();
  const subModuleKey = String(subModule || "").toUpperCase();
  const actionKey = String(action || "").toLowerCase();

  const actionAliases = {
    list: ["list", "view"],
    view: ["view", "list"],
    update: ["update", "edit"],
    edit: ["edit", "update"],
    create: ["create", "add"],
    add: ["add", "create"],
    remove: ["remove", "delete"],
    delete: ["delete", "remove"],
  };

  const candidateActions = actionAliases[actionKey] || [actionKey];
  const isTruthy = (val) =>
    val === true ||
    val === "true" ||
    (typeof val === "string" && val.trim().toLowerCase() === "true");

  const hasAction = (obj) =>
    candidateActions.some((act) => {
      if (!obj) return false;
      if (obj.actions && isTruthy(obj.actions[act])) return true;
      return isTruthy(obj[act]);
    });

  let root = permissions;
  while (root && typeof root === "object") {
    if (root.defaultPrivileges && typeof root.defaultPrivileges === "object") {
      root = root.defaultPrivileges;
    } else if (root.permissions && typeof root.permissions === "object" && !root.permissions["*"]) {
      root = root.permissions;
    } else if (root.modules && typeof root.modules === "object") {
      root = root.modules;
    } else if (root.privileges && typeof root.privileges === "object") {
      root = root.privileges;
    } else {
      break;
    }
  }

  const moduleNode = root[moduleKey] || root[moduleKey.toLowerCase()];
  const subModuleNode =
    moduleNode?.[subModuleKey] ||
    moduleNode?.[subModuleKey.toLowerCase()] ||
    moduleNode?.subModules?.[subModuleKey] ||
    moduleNode?.subModules?.[subModuleKey.toLowerCase()];
  const wildcardModuleNode = root?.["*"];

  return Boolean(
    moduleNode?.all === true ||
    moduleNode?.["*"] === true ||
    hasAction(moduleNode) ||
    moduleNode?.["*"]?.["*"] === true ||
    subModuleNode?.all === true ||
    hasAction(subModuleNode) ||
    subModuleNode?.["*"] === true ||
    wildcardModuleNode?.all === true ||
    wildcardModuleNode?.[subModuleKey]?.all === true ||
    hasAction(wildcardModuleNode?.[subModuleKey]) ||
    hasAction(wildcardModuleNode?.["*"])
  );
}

export function canModule(permissions, module) {
  if (!permissions) return false;
  if (permissions?.["*"]?.["*"]?.["*"]) return true;

  const moduleKey = String(module || "").toUpperCase();
  const moduleNode = permissions?.[moduleKey];
  if (!moduleNode || typeof moduleNode !== "object") return false;

  if (moduleNode.all === true || moduleNode?.["*"]?.["*"] === true) {
    return true;
  }

  return Object.values(moduleNode).some((subNode) => {
    if (!subNode || typeof subNode !== "object") return false;
    if (subNode.all === true || subNode["*"] === true) return true;
    return Object.values(subNode).some((allowed) => allowed === true);
  });
}
